import { useCallback } from 'react';
import { CmsEvent } from '../models/EventResult';
import { gql } from '@apollo/client';
import { graphql } from '@xolv-mybrightlink/common';

const FETCH_BOOKMARKED_EVENT_SLUGS = gql`
  query bookmarkedSlugs($slugs: [String]) {
    bookmarkedSlugs(type: "event", slugs: $slugs)
  }
`;

export const useFetchBookmarkedEvents = () => {
  return useCallback(async (events: CmsEvent[]) => {
    const slugs = events.map((event) => event.slug);
    if (slugs.length === 0) {
      return [];
    }
    const response = await graphql.query<{ bookmarkedSlugs: string[] }>({
      query: FETCH_BOOKMARKED_EVENT_SLUGS,
      variables: { slugs },
      fetchPolicy: 'no-cache',
    });
    const bookmarkedSlugs = response.data.bookmarkedSlugs;
    return events.map((event) => {
      const isSaved = bookmarkedSlugs.some((slug) => slug === event.slug);
      return { ...event, isSaved };
    });
  }, []);
};
